import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M17.243-.757 17 19.122",
      style: {"fill":"none","fill-rule":"nonzero","stroke-width":"2.07px"},
      transform: "matrix(.01229 .99992 -1.00594 .01221 21.027 -1.232)"
    }, null, -1),
    _createElementVNode("path", {
      d: "M17.243-.757 17 19.122",
      style: {"fill":"none","fill-rule":"nonzero","stroke-width":"2.07px"},
      transform: "matrix(.99992 -.01229 .01221 1.00594 -9.232 2.973)"
    }, null, -1),
    _createElementVNode("path", {
      d: "M17.243-.757 17 19.122",
      style: {"fill":"none","fill-rule":"nonzero","stroke-width":"2.07px"},
      transform: "matrix(.99992 -.01229 .01221 1.00594 -1.232 2.973)"
    }, null, -1),
    _createElementVNode("path", {
      d: "M17.243-.757 17 19.122",
      style: {"fill":"none","fill-rule":"nonzero","stroke-width":"2.07px"},
      transform: "matrix(.01229 .99992 -1.00594 .01221 21.027 -9.232)"
    }, null, -1)
  ]))]))
}
export default { render: render }